var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHardwareSubscriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.1875H3.5C2.77513 2.1875 2.1875 2.77513 2.1875 3.5V10.5C2.1875 11.2249 2.77513 11.8125 3.5 11.8125H10.5C11.2249 11.8125 11.8125 11.2249 11.8125 10.5V3.5C11.8125 2.77513 11.2249 2.1875 10.5 2.1875Z",
    stroke: "#006AB3",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 3.9375H4.375C4.13338 3.9375 3.9375 4.13338 3.9375 4.375V9.625C3.9375 9.86662 4.13338 10.0625 4.375 10.0625H9.625C9.86662 10.0625 10.0625 9.86662 10.0625 9.625V4.375C10.0625 4.13338 9.86662 3.9375 9.625 3.9375Z",
    stroke: "#006AB3",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.1875V1.3125M9.1875 2.1875V1.3125M4.8125 2.1875V1.3125M7 12.6875V11.8125M9.1875 12.6875V11.8125M4.8125 12.6875V11.8125M11.8125 7H12.6875M11.8125 9.1875H12.6875M11.8125 4.8125H12.6875M1.3125 7H2.1875M1.3125 9.1875H2.1875M1.3125 4.8125H2.1875",
    stroke: "#006AB3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardwareSubscriptionIcon);
export default __webpack_public_path__ + "static/media/hardware_subscription_icon.c710c01b2931bc59ea488fb3aefd9f6d.svg";
export { ForwardRef as ReactComponent };